import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hire-us-footer',
  templateUrl: './hire-us-footer.component.html',
  styleUrls: ['./hire-us-footer.component.sass']
})
export class HireUsFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
